import src from "IMAGE";
export default { src, width: 2075, height: 386, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAELCAAohWgKRb2YKkfAmztHwJs7RL2XKSeCZQkBCgcAoFkJnGUvcV4AAAAASUVORK5CYII="};
